export enum MatomoPeriod {
    Day,
    Week,
    Month,
    Year   
}
